import React from 'react';
import './About.css';
import tanjin from '../../../images/me2.jpg';

const About = () => {
    return (
        <div className="container about">
            <div className="mb-5 pt-5 pb-5">
                <div className='row d-flex'>
                    <div className="col-md-6 mt-5">
                        <div className="img">
                            <img className="img-fluid w-50 d-block tanjin" src={tanjin} alt="" />
                        </div>
                        <h2 className="text-left mt-3 mb-2" style={{ fontSize: "2.2rem" }}>
                            <small className="text-green">I'm</small>
                             Tanjin Ahamed
                        </h2>
                        <p className="text-left" style={{ fontSize: "1.3rem" }}>To obtain a responsible and challenging Front-end Developer position at Brain Station 23 to apply solid
                        education and work experience to the maximum. Looking for a difficult yet rewarding career with a
                        progressive association that gives the chance to improve.</p>
                    </div>
                    <div className="col-md-6 px-5">
                        <div className="my-5 ">
                            <h4 className="page-title mb-3 text-left skil">My skills Set</h4>
                            <div className="technology">
                                <span>JavaScripts</span>
                                <span>ES6</span>
                                <span>React.js</span>
                                <span>Node.js</span>
                                <span>Express.js</span>
                                <span>MongoDb</span>
                                <span>Git</span>
                                <span>NPM</span>
                                <span>VS Code</span>
                                <span>Rest API</span>
                                <span>Firebase</span>
                                <span>Heroku</span>
                                <span>C</span>
                                <span>Python</span>
                            </div>

                        </div>
                        <h4 className="page-title text-left pt-3 mt-5 mb-3 skil">I want to work with</h4>
                        <div className="technology">
                            <span>JavaScript</span>
                            <span>React.js</span>
                            <span>Node.js</span>
                            <span>REST API</span>
                            <span>MongoDb</span>
                        </div>
                        <h4 className="page-title text-left pt-3 mt-5 mb-3 skil">I prefer not to work with</h4>
                        <div className="technology">
                            <span>PHP</span>
                            <span>Laravel</span>
                            <span>MySQL</span>
                            <span>Wordpress</span>
                            <span>jQuery</span>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default About;